import styled from '@emotion/styled/macro';
import { Popover, Variables } from '@enter/core';
import { Icon } from '@mdi/react';
import { Link } from 'react-router-dom';

export const StyledPopover = styled(Popover)``;

export const ActionButton = styled.button`
    cursor: pointer;
    padding: 5px 4px 5px 8px;
    line-height: 16px;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.2px;
    color: ${Variables.Colors.p200};
    background-color: ${Variables.Colors.white};
    border: ${Variables.Borders.regular};
    border-radius: ${Variables.Rounded.small};
    outline: none;
`;

export const ActionButtonIcon = styled(Icon)`
    margin-left: 2px;
    height: 18px;
    width: 18px;
    vertical-align: text-bottom;
    fill: ${Variables.Colors.p200};
`;

export const LinkItem = styled(Link)`
    color: inherit;
`;
